<script setup lang="ts">
    const props = defineProps<{
        loginModalController: ReturnType<typeof useModal>;
        modalId?: string;
    }>();

    const closeButtonRef = ref();
    const { t } = useI18n();

    const { shopwareDown } = useShopwareDowntime();

    watch(
        () => props.loginModalController.isOpen.value,
        async (open) => {
            if (open) {
                await nextTick();
                closeButtonRef.value?.focus();
            }
        }
    );

    const loginModal = useLoginModal();
</script>

<template>
    <ClientOnly>
        <SharedModal
            :controller="props.loginModalController"
            :modal-id="props.modalId"
            class="modal-container"
        >
            <SharedCloseButton
                ref="closeButtonRef"
                :label="t('general.close')"
                @click="props.loginModalController.close"
            />
            <AccountLoginForm
                @close="props.loginModalController.close"
                @success="props.loginModalController.close"
            >
                <template v-if="shopwareDown">
                    <div class="login-error">
                        <p>{{ t('errors.shopwareLoginError') }}</p>
                    </div>
                </template>
                <template
                    v-if="loginModal?.headline || loginModal?.contentUuid"
                    #advantages
                >
                    <Advantages
                        :title="loginModal?.headline"
                        :story-id="loginModal?.contentUuid"
                    />
                </template>
            </AccountLoginForm>
        </SharedModal>

        <template #fallback>
            <span style="display: none" />
        </template>
    </ClientOnly>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/basics/shared-login-modal.scss';
</style>
